module.exports = __webpack_public_path__ + "static/calendar-23457d4ca3789ba2b658e3aab6f90e0f.png";